import React, { useEffect, useState } from 'react';
import MainLayout from '../../containers/MainLayout';
import PageTitle from '../../baseComponents/PageTitle'
import { getTimeLineData } from '../../services/history';
import { connect } from 'react-redux';

import Loader from '../../baseComponents/Loader';
import TimeLineResume from './components/TimeLineResume';
import FirstDateType from './components/TypeDateComponents/FirstType';
import SecondDateType from './components/TypeDateComponents/SecondType';
import ThirdDateType from './components/TypeDateComponents/ThirdType';
import QuarterDateType from './components/TypeDateComponents/QuarterType';
import FifthType from './components/TypeDateComponents/FifthType';
import SixhtType from './components/TypeDateComponents/SixhtType';
import SeventhType from './components/TypeDateComponents/SeventhType';
import EightType from './components/TypeDateComponents/EightType';
import NinethType from './components/TypeDateComponents/NinethType';
import TenthType from './components/TypeDateComponents/TenthType';
import EleventhType from './components/TypeDateComponents/EleventhType';
import TwelfthType from './components/TypeDateComponents/TwelfthType';

import daslLine from '../../assets/images/dash.png';

import './index.css';

const History = (props) => {
  const { lang } = props.settings;
  const [isFetching, setIsFetching] = useState(true),
    [activeClass, setActiveClass] = useState(''),
    [resume, setResume] = useState({}),
    [timeLine, setTimeLine] = useState({}),
    [distance, setDistance] = useState(''),
    [activePoint, setActivePoint] = useState(0),
    [timelineData, setTimelineData] = useState({});

  const getInitialData = async () => {
    try {
      const response = await getTimeLineData();
      setTimelineData(response.data);
      const { resume, timeLine } = response.data[lang];
      setTimeLine(timeLine);
      setResume(resume);
      setIsFetching(false);
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    getInitialData();
    let timeout = null;
    timeout = setTimeout(() => {
      setActiveClass('active');
    }, 1000);
    return () => {
      clearTimeout(timeout);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (Object.entries(timelineData).length !== 0) {
      const { resume, timeLine } = timelineData[lang];
      setTimeLine(timeLine);
      setResume(resume);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [lang]);

  const getYearCard = (item, index) => {
    switch (item.type) {
      case 1:
        return (
          <FirstDateType
            data={item}
            index={index}
            activePoint={activePoint}
            setActivePoint={setActivePoint}
          />
        );
      case 2:
        return (
          <SecondDateType
            data={item}
            index={index}
            activePoint={activePoint}
            setActivePoint={setActivePoint}
          />
        );
      case 3:
        return (
          <ThirdDateType
            data={item}
            index={index}
            activePoint={activePoint}
            setActivePoint={setActivePoint}
          />
        );
      case 4:
        return (
          <QuarterDateType
            data={item}
            index={index}
            activePoint={activePoint}
            setActivePoint={setActivePoint}
          />
        );

      case 5:
        return (
          <FifthType
            data={item}
            index={index}
            activePoint={activePoint}
            setActivePoint={setActivePoint}
          />
        );
      case 6:
        return (
          <SixhtType
            data={item}
            index={index}
            activePoint={activePoint}
            setActivePoint={setActivePoint}
          />
        );
      case 7:
        return (
          <SeventhType
            data={item}
            index={index}
            activePoint={activePoint}
            setActivePoint={setActivePoint}
          />
        );
      case 8:
        return (
          <EightType
            data={item}
            index={index}
            activePoint={activePoint}
            setActivePoint={setActivePoint}
          />
        );
      case 9:
        return (
          <NinethType
            data={item}
            index={index}
            activePoint={activePoint}
            setActivePoint={setActivePoint}
          />
        );
      case 10:
        return (
          <TenthType
            data={item}
            index={index}
            activePoint={activePoint}
            setActivePoint={setActivePoint}
          />
        );
      case 11:
        return (
          <EleventhType
            data={item}
            index={index}
            activePoint={activePoint}
            setActivePoint={setActivePoint}
          />
        );
      case 12:
        return (
          <TwelfthType
            data={item}
            index={index}
            activePoint={activePoint}
            setActivePoint={setActivePoint}
          />
        );
      default:
        return null;
    }
  };

  if (isFetching) return <Loader />
  return (
    <MainLayout id='history' className={`${activeClass}`}>
      <div id='history_container' className='history_container transition'>
        <div id='history-resume' className='resume'>
          <div>
            <PageTitle withCross={true} title={resume.title} label={resume.subtitle} />
            <div
              className='paragraph_resume'
              dangerouslySetInnerHTML={{ __html: resume.body }}
            />
          </div>

          <div className='opacity-0'>
            <TimeLineResume
              data={timeLine}
              distance={distance}
              setDistance={setDistance}
              activePoint={activePoint}
              setActivePoint={setActivePoint}
            />
          </div>
        </div>
        <div className='time_line_cards'>
          <div className='time_line_cards-background' />
          <div className='dash_image_line_container '>
            <div className='initialoval_black' />
            <div className='dash_image_line' />
          </div>
          <div className='dash_image' style={{ background: `url(${daslLine})` }} alt='dash' />
          {timeLine.yearsCard.map((item, index) => {
            return (
              <div
                id={`year-${index}`}
                key={index}
                type={`${item.type === 9 || item.type === 11 ? 'double_card' : 'card'} `}
                className={
                  `
                  ${item.type === 9 || item.type === 11 ? 'double_card' : 'card'} 
                  type-${item.type}
                  ${activePoint === index ? 'active-point' : ''}
                  `}
                style={{ position: 'relative' }}
              >
                {getYearCard(item, index)}
              </div>
            );
          })}
        </div>
      </div>
      <TimeLineResume
        data={timeLine}
        distance={distance}
        setDistance={setDistance}
        activePoint={activePoint}
        setActivePoint={setActivePoint}
      />
    </MainLayout>
  );
};

const mapStateToProps = (state) => ({
  settings: state.settings,
});

export default connect(mapStateToProps)(History);

// <span style={{ background: 'red', position: 'absolute', top: '2vmin' }}>Tipo: {item.type}</span>
